export default __webpack_public_path__ + "static/media/cleansing_heart.67c950d0.png";